import { render, staticRenderFns } from "./blackWhitePhotoColoring.vue?vue&type=template&id=ee6e0e08&scoped=true&"
import script from "./blackWhitePhotoColoring.vue?vue&type=script&lang=js&"
export * from "./blackWhitePhotoColoring.vue?vue&type=script&lang=js&"
import style0 from "./blackWhitePhotoColoring.vue?vue&type=style&index=0&id=ee6e0e08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6e0e08",
  null
  
)

export default component.exports